import { GADataLayerType, DataLayer } from './google-analytics.types'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

const addDataLayer = (dataLayer: GADataLayerType) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(dataLayer)
}

export const GoogleAnalyticsDataLayer = {
  sendPageInteraction(data: DataLayer) {
    addDataLayer(data.toGADataLayerType())
  }
}

export const addCustomEventToGoogleDataLayer = customDataLayerEvent => {
  addDataLayer(customDataLayerEvent)
}
